import { Command } from 'commander'
import { VERSION } from '../index.js'
import { showStatus } from './status.js'
import { runSetup } from './setup.js'
import { runDoctor } from './doctor.js'
import { runUninstall } from './uninstall.js'

export function createProgram(): Command {
  const program = new Command()

  program
    .name('gsd-munch')
    .version(VERSION)
    .description('GSD workflow orchestration + jCodeMunch code indexing for Claude Code')
    .action(() => {
      showStatus()
    })

  program
    .command('setup')
    .description('Provision Python/uv and register jCodeMunch MCP server')
    .option('--project', 'Register MCP server at project scope (.mcp.json)')
    .action(async (opts: { project?: boolean }) => {
      await runSetup(opts)
    })

  program
    .command('doctor')
    .description('Check installation health (flutter doctor pattern)')
    .action(async () => {
      await runDoctor()
    })

  program
    .command('uninstall')
    .description('Remove all gsd-munch files from ~/.claude/')
    .action(async () => {
      await runUninstall()
    })

  return program
}
